export default __webpack_public_path__ + "assets/ocf-modal-image.png";